import React from 'react';
import Widget from './Widget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faEye, faVideo } from '@fortawesome/free-solid-svg-icons';

const VideoWidget = ({ id, onClick, hidden = false }) => {
  return (
    <Widget
      id={id}
      onClick={onClick}
      icon={<FontAwesomeIcon icon={faPlay} />}
      title="Chess Videos"
      subtitle="YouTube & Twitch content"
      hidden={hidden}
    >
      <div className="flex flex-col items-center justify-center h-full p-4 text-center">
        <div className="text-gray-400 text-3xl mb-3">
          <FontAwesomeIcon icon={faPlay} />
        </div>
        <div className="text-gray-300 text-sm font-medium mb-2">
          Chess Videos
        </div>
        <div className="text-gray-500 text-xs mb-3">
          YouTube & Twitch content hub
        </div>
        <div className="flex items-center space-x-3 text-xs text-gray-400">
          <div className="flex items-center">
            <FontAwesomeIcon icon={faVideo} className="text-red-500 mr-1" />
            <span>YouTube</span>
          </div>
          <div className="flex items-center">
            <FontAwesomeIcon icon={faVideo} className="text-purple-500 mr-1" />
            <span>Twitch</span>
          </div>
        </div>
        <div className="flex items-center mt-1 text-xs text-gray-400">
          <FontAwesomeIcon icon={faEye} className="mr-1" />
          <span>1.2M+ views</span>
        </div>
      </div>
    </Widget>
  );
};

export default VideoWidget;